import React, { } from "react";
import "./index.scss";
const Head = () => {

    return (
        <>
            <div className="head text-center">
                <h2>Simple, Transparent Pricing</h2>
                <h3>No hidden, No surprise fees</h3>
            </div>
        </>
    )
};
export default Head;